<template>
  <div
    @click="$emit('click')"
    :class="`bg-white overflow-${overflow} border border-slate-200 rounded-lg ${extraClasses}`"
  >
    <div class="px-4 py-5 sm:p-6">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extraClasses: {
      type: String,
      required: false,
      default: '',
    },
    overflow: {
      type: String,
      default: 'hidden',
      required: false,
    },
  },
};
</script>
